import { lstat } from 'fs'
import { Link } from 'gatsby'
import React from 'react'
import styled from 'styled-components'
import useWindowSize from '../../hooks/useWindow'
import Fr from './Fr'
import Logo from './Logo'
import Menu from './Menu'
const NavbarWrapper = styled.div`
    margin: 13px 40px;
  
    &::after{
        content: '';
    position: absolute;
    width: 100%;
    height: 1px;
    background: rgba(255, 255, 255, 0.5);
box-shadow: 0px 1px 0px rgba(0, 0, 0, 0.12);
backdrop-filter: blur(54px);
    top: 6rem;
    left: 0;
    }
    @media screen and (max-width:740px) {
    margin-top: 20px;
    margin-bottom: 20px;
    margin-left: 16px;
    margin-right: 20px;
    }
`
const NavbarFlex = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
`
const NavElements= styled.div`
    display:flex;
    flex-direction: row;
    align-items: center;
    flex: 1;
    justify-content: end;
    gap:24px;
    margin: 13px 0;
    @media screen and (max-width:740px) {
        display:none;
    }
`
const LinkNav = styled(Link)`
font-size: 16px;
font-weight: 400;
font-family: 'Outfit';
font-style: normal;
line-height: 20px;
color: #39394C;
`
const Burger =styled.div`
svg {
    cursor: pointer;
}
@media screen and (min-width:740px) {
    display: none;
}
@media screen and (max-width:740px) {
    flex:1;
justify-content: end;
display: flex;
}
`
interface NavbarProps {

}

const Navbar: React.FC<NavbarProps> = ({}) => {
    const [isOpen,setOpen] = React.useState(false)
    const [isMenu, setMenu] = React.useState(false) //Mobile menu state.
    const {width} = useWindowSize() // A hook to measure window's width.
    let str = ''

    React.useEffect(()=>{
        if(width > 740)
         {
            setMenu(false)
         }
    },[width])

    if(typeof window !== 'undefined') {
     let location = window.location.pathname //Gets the pathname of url.
     str = location.replace(/^\/([^\/]*).*$/, '$1') // Gets the second uri of an url.
     let last_segment  = window.location.pathname.split('/'); // Gets the last uri of an url.
     if(str) {
        if(last_segment.length ==3 && last_segment[2] !== '')
        {
         let doc = document.querySelector('.'+ last_segment[2])
         doc?.classList.add('active')
        }
        
        else if (last_segment.length ==2 || last_segment[2] == ''){
        let doc = document.querySelector('.'+ last_segment[1])
        doc?.classList.add('active')
        }
        
    }
    }
    
    
    React.useEffect(() => {
        const body = document.querySelector('body');
        if(isOpen) {
           
            body.style.overflow = 'hidden'
        }
        else  body.style.overflow = 'unset'
    }, [isOpen])
    React.useEffect(()=>
  {
    if(typeof window !== "undefined"){
    const navbar = document.querySelector('.navbar')  as HTMLElement | null
     
        navbar?.classList.remove('stickyy')
        const height = navbar?.offsetHeight
        const y_pos = navbar?.offsetTop
       document.addEventListener('scroll', e =>{
         const scroll= window.scrollY
         
         if(scroll >height +y_pos) // You can ignore this error.
         {
         navbar?.classList.add('sticky')
         }else if (scroll <= y_pos +200)// You can ignore this error.
         {
          navbar?.classList.remove('sticky')
         }
        
       })
     
    //   else if(width  <= '500')
    //   {
    //     navbar?.classList.add('stickyy')
    //   }
     
  }
  },[width])

        return (
            <>
             <NavbarWrapper className='navbar'>
                <NavbarFlex>
                    <Logo />
                    <NavElements className='hover'>
                    {str == 'fr-fr'? 
                        <LinkNav className='a-propos' to='/fr-fr/a-propos'>A propos</LinkNav>
                        :
                        <LinkNav className='about' to='/about'>About us</LinkNav>
                        }    
                       {str == 'fr-fr'? 
                        <LinkNav className='nos-services' to='/fr-fr/nos-services'>Nos services</LinkNav>
                        :
                        <LinkNav className='services' to='/services'>Services</LinkNav>
                        } 
                        {str == 'fr-fr'? 
                        <LinkNav className='resource' to='/fr-fr/resource'>Nos projets</LinkNav>
                        :
                        <LinkNav className='resource' to='/en-us/resource'>Our work</LinkNav>
                        } 
                       {str == 'fr-fr'? 
                        <LinkNav className='nos-contacter' to='/fr-fr/nos-contacter'>Nous contacter</LinkNav>
                        :
                        <LinkNav className='contact' to='/contact'>Contact us</LinkNav>
                        } 
                    <Fr />
                    </NavElements>
                    <Burger>
                        {!isMenu ?
                        (
                    <svg  onClick={() =>{ setMenu(!isMenu); setOpen(true)}} width="24" height="16" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect y="7.11108" width="24" height="1.77778" rx="0.888889" fill="#39394C"/>
                        <rect y="14.2222" width="24" height="1.77778" rx="0.888889" fill="#39394C"/>
                        <rect width="24" height="1.77778" rx="0.888889" fill="#39394C"/>
                    </svg>
                        ):
                        (
                        <svg onClick={() => {setMenu(!isMenu) ; setOpen(false) }} width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect x="1.25781" y="0.00012207" width="24" height="1.77778" rx="0.888889" transform="rotate(45 1.25781 0.00012207)" fill="#39394C"/>
                            <rect x="18.2285" y="1.25708" width="24" height="1.77778" rx="0.888889" transform="rotate(135 18.2285 1.25708)" fill="#39394C"/>
                        </svg>
                        )
                        }
                    </Burger>
                </NavbarFlex>
              
            </NavbarWrapper>
            {isMenu && (
                <Menu />
            )}
            </>
           
             
        );
}
export default Navbar
